import React from "react";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import dataProvider from "server/dataProvider";
import { graduationRequests } from "api/graduationApi";
import { Button, useNotify } from "react-admin";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";

const RemoveStudentDialog = ({ intervalId, studentEducationId, fetchStudents }) => {
  const notify = useNotify();
  const handleSubmit = async () => {
    await dataProvider.customRequest(
      graduationRequests.removeStudentFromIndividualSlotInterval(intervalId, studentEducationId),
      null,
      "DELETE",
    );
    fetchStudents();
    notify("Успешно премахване на студент от часовия интервал", { type: "success" });
  };
  return (
    <ConfirmModal
      onConfirm={handleSubmit}
      titleContent={"Премахване на студент от часовия интервал"}
      message="Сигурни ли сте, че искате да премахнете студента?"
      triggerButton={
        <Button
          startIcon={<RemoveCircleOutlineIcon />}
          color="error"
          variant="outlined"
          label="Премахни студент"
        />
      }
    />
  );
};

export default RemoveStudentDialog;
